/** Type tokens — docs/sprocket-design-language.md §2. Sizes in px; the theme converts to rem. */
/** Geist, self-hosted via @fontsource-variable (imported once by the theme provider). */
export const FONT_FAMILY = {
    sans: [
        '"Geist Variable"',
        'Geist',
        'ui-sans-serif',
        'system-ui',
        '-apple-system',
        '"Segoe UI"',
        'Roboto',
        'sans-serif',
    ].join(','),
    /** Identifiers only — policy numbers, keys, codes. */
    mono: [
        '"Geist Mono Variable"',
        '"Geist Mono"',
        'ui-monospace',
        'SFMono-Regular',
        'Menlo',
        'Consolas',
        'monospace',
    ].join(','),
};
/** The scale (§2). Headings tighten as they grow; body line-height 1.5; headings 1.15–1.35. */
export const TYPE = {
    display: { size: 28, weight: 600, lineHeight: 1.15, tracking: '-0.02em', family: 'sans' },
    pageTitle: { size: 22, weight: 600, lineHeight: 1.2, tracking: '-0.015em', family: 'sans' },
    section: { size: 18, weight: 600, lineHeight: 1.3, tracking: '-0.01em', family: 'sans' },
    cardTitle: { size: 14, weight: 600, lineHeight: 1.45, tracking: '0', family: 'sans' },
    body: { size: 14, weight: 400, lineHeight: 1.5, tracking: '0', family: 'sans' },
    bodySmall: { size: 13, weight: 400, lineHeight: 1.5, tracking: '0', family: 'sans' },
    label: { size: 13.5, weight: 500, lineHeight: 1.45, tracking: '0', family: 'sans' },
    caption: { size: 12, weight: 400, lineHeight: 1.45, tracking: '0', family: 'sans' },
    micro: { size: 11.5, weight: 500, lineHeight: 1.4, tracking: '0.02em', family: 'sans' },
    identifier: { size: 12.5, weight: 400, lineHeight: 1.4, tracking: '0', family: 'mono' },
    button: { size: 13, weight: 500, lineHeight: 1, tracking: '0', family: 'sans' },
};
/** Nothing renders smaller than this (§2). */
export const TYPE_MIN_PX = 11.5;
/** Root font size the rem scale is built on. */
export const REM_BASE = 16;
export const rem = (px) => `${px / REM_BASE}rem`;
/** Spread into `sx` on anything whose digits sit in a column (§1.3). */
export const TABULAR = { fontVariantNumeric: 'tabular-nums' };
/** Spread into `sx` on identifiers (§2 "Identifier"). */
export const MONO = { fontFamily: FONT_FAMILY.mono, fontSize: rem(TYPE.identifier.size) };
//# sourceMappingURL=type.js.map